import React, {useEffect, useRef} from 'react';
import './Popup.less';
import ScrollHelper from "helpers/scroll.helper";
import {InlineSpinner, InlineSpinnerStyles} from "../../elements/inline-spinner/InlineSpinner";

export const Popup = ({topStaticControl, children, bottomStaticControl, isLoading = false}) => {
	const containerElement = useRef(null);

	useEffect(() => {
		const scroll = ScrollHelper.initIScroll(containerElement.current, {
			scrollX: false,
			scrollY: true,
			scrollbars: true
		});

		return () => {
			scroll && scroll.destroy();
		};
	}, []);

	return <div className="popup">
		{
			topStaticControl && (<div className="popup__top-static-control">
				{topStaticControl}
			</div>)
		}
		<div className="popup__contents" ref={containerElement}>
			<div className="popup__container">
				{children}
			</div>
		</div>
		{
			bottomStaticControl && (<div className="popup__bottom-static-control">
				{bottomStaticControl}
			</div>)
		}
		{
			isLoading && <div className="popup__loading">
				<div className="popup__loading-spinner">
					<InlineSpinner/>
				</div>
			</div>
		}
	</div>;
}
